export default "__VITE_ASSET__GYVNMfKZ__"